import { refusalOf, wordingOf } from './refusal'

export function popupRefusalOf(error, { labelOf, fieldNames, codeFields = {} }) {
    const { fieldErrors } = refusalOf(error, { labelOf })
    const validations = error?.response?.data?.error?.details?.validations ?? []

    const codeErrors = validations
        .filter((validation) => validation.params?.field == null && codeFields[validation.code] != null)
        .map((validation) => [codeFields[validation.code], wordingOf(validation.code, validation.params)])
    const allFieldErrors = {
        ...fieldErrors,
        ...Object.fromEntries(codeErrors),
    }

    const shownFieldErrors = Object.fromEntries(
        Object.entries(allFieldErrors).filter(([field]) => fieldNames.includes(field)),
    )

    return {
        fieldErrors: shownFieldErrors,
    }
}
